module.exports = __webpack_public_path__ + "img/Han.96f0e6cb.jpg";